import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrayerStatus } from '../../../../models/prayer.model';

@Component({
  selector: 'app-btn-prayer-status',
  standalone: true,
  templateUrl: './btn-prayer-status.component.html',
  styleUrls: ['./btn-prayer-status.component.css'],
})
export class BtnPrayerStatusComponent {
  @Input() status: PrayerStatus | undefined = PrayerStatus.unknown;
  @Input() isDisabled: boolean = false;

  @Output() onClick: EventEmitter<PrayerStatus> = new EventEmitter();

  prayerStatus = PrayerStatus;

  constructor() {}
}
